import * as React from 'react';

import './AppAlert.css';

interface IAppAlert {
    className: string,
    message: string
}

const AppAlert: React.SFC<IAppAlert> = (props) => {
    return (
        <div className="alert">
            <div className={`alert-${props.className}`}>
                {props.message} 
            </div>
        </div>
    );
}

export default AppAlert;
